if ($(".product__gallery").length) {

	(function() {

		var productGallery = null;
		var productThumbs = null;

		productGallery = new Swiper.default(".product-gallery__main .swiper-container", {
			keyboard: {
			    enabled: true,
			    onlyInViewport: true,
			},
			watchOverflow: true,
			on: {
				transitionStart: function() {

					if (!productThumbs) {
						return;
					}

					var swiper = this;

					var activeSlide = $(swiper.slides[swiper.previousIndex]);

					$(productThumbs.slides).removeClass("swiper-slide-current");
					$(productThumbs.slides[swiper.activeIndex]).addClass("swiper-slide-current");

					var currentSlide = $(productThumbs.slides[swiper.activeIndex]);
					var nextSlide = currentSlide.next(".swiper-slide");
					var prevSlide = currentSlide.prev(".swiper-slide");
					var visibleItemsCount = $(productThumbs.slides).filter(".swiper-slide-visible").length;

					if (nextSlide.length && !nextSlide.hasClass("swiper-slide-visible")) {

						var nextPageIndex = Math.floor(swiper.activeIndex);

						// slide to next page
						productThumbs.slideTo(
							Math.min(productThumbs.slides.length - 1, Math.max(0, nextPageIndex))
						);
					}
					else if (prevSlide.length && !prevSlide.hasClass("swiper-slide-visible")) {
						var prevPageIndex = Math.floor(swiper.activeIndex);

						// slide to prev page
						productThumbs.slideTo(
							Math.min(productThumbs.slides.length - 1, Math.max(0, prevPageIndex))
						);
					}
					else if (!currentSlide.hasClass("swiper-slide-visible")) {
						productThumbs.slideTo(swiper.activeIndex);
					}
				},
				transitionEnd: function(swiper) {

					var swiper = this;

					if (typeof productThumbs != "undefined") {
						$(productThumbs.slides).removeClass("swiper-slide-current");

						var currentSlide = $(productThumbs.slides[swiper.activeIndex]);
						currentSlide.addClass("swiper-slide-current");
					}
				}
			}

		});

		productThumbs = new Swiper.default(".product-gallery__thumbs .swiper-container", {
			spaceBetween: 10,
			slidesPerView: "auto",
			freeMode: true,
			scrollbar: {
				el: ".swiper-scrollbar",
				hide: true
			},
			freeModeMomentumRatio: 0.4,
			watchSlidesVisibility: true,
			on: {
				init: function() {
					$(this.slides[0]).addClass("swiper-slide-current");
				}
			}
		});

		// productGallery.params.control = productThumbs;

		$(document).on("click", ".product-gallery__thumbs .swiper-slide", function(e) {
			e.preventDefault();

			productGallery.slideTo(productThumbs.clickedIndex);

		});

		let stopYoutubeVideo = function() {
					
			$(this.container).find("iframe").each(function() {
			  this.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
			});

		};

		// Photoswipe init				
		$(".product__gallery").photoSwipe(
			".product-gallery__lightbox",
			{
				bgOpacity: 0.8,
				shareEl: false,
				captionEl: false,
				tapToClose: true
			},
			{
				beforeChange: function() {
					stopYoutubeVideo.call(this);
				},

				close: function() {
					stopYoutubeVideo.call(this);
				}
			}
		);

	})();

}

